import { createSlice } from "@reduxjs/toolkit";
import { fetchFeaturedvendorsItems } from "./FeaturedvendorsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const featuredvendorsSlice = createSlice({
  name: "featuredvendors",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFeaturedvendorsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeaturedvendorsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchFeaturedvendorsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default featuredvendorsSlice.reducer;